import React from 'react';

import i18n from 'i18next';

import { Icon } from 'uikit/icons';
import { Typo } from 'uikit/content';

import styles from '../styles/insightsDashboardsEmpty.module.scss';

const InsightsDashboards = () => (
  <div className={styles.container}>
    <div className={styles.element}>
      <Icon className={styles.icon} icon="insights" size={48} />
      <div>
        <Typo className={styles.title} element="h5" weight="bold">
          {i18n.t('insights-dashboards-empty-title')}
        </Typo>
        <Typo className={styles.body} color="secondary">
          {i18n.t('insights-dashboards-empty-body')}
        </Typo>
        <Typo className={styles.instruction} variant="b01" weight="medium">
          {i18n.t('insights-dashboards-empty-instruction')}
        </Typo>
      </div>
    </div>
  </div>
);

export default React.memo(InsightsDashboards);
